<template>
  <div id="custom_template">
    <div id="header">
      <div id="logo">
        <img
          alt="Montage Portal Page Logo"
          src="./assets/montage-logo.png"
        />
      </div>
    </div>

    <!---REG METHODS BLOCK -->
    <div v-if="registration_methods.length > 0" id="rms" class="rms">
      <registration-method
        v-for="(registration_method, index) in registration_methods"
        :key="index"
        :index="index"
        :hotelCode="hotelCode"
        :registration_method="registration_method"
        :selected="doc.selected_rm"
        :selected_tos="doc.selected_tos"
        v-on:changeSelected="changeSelected"
        v-on:changeSelectedTOS="changeSelectedTOS"
        v-on:emitRegistrationMethodData="emitRegistrationMethodData"
      />
    </div>
  </div>
</template>

<script>
import RegistrationMethod from "@/components/custom/montage/CustomMontageMethods";
import axios from "axios";

export default {
  name: "custom_template",
  props: ["portal", "connection_data"],
  components: {
    "registration-method": RegistrationMethod,
  },
  watch: {
    // Collapse the Terms of Service when registration method changes
    "doc.selected_rm": function () {
      this.doc.selected_tos = null;
    },
  },
  data() {
    return {
      doc: {
        window_width: window.innerWidth,
        selected_rm: null,
        selected_tos: null,
        selected_inline_image: 0,
        selected_background_image: 0,
        support_phone: "8772822519",
      },
      emitted: {},
      registration_methods: [],
      // unique hotel code per property
      hotelCode: 'MDV',
      // Manually setting this up here because not in endpoint
      terms_of_service: `<b>TERMS AND CONDITIONS<br>OF INTERNET USE</b><br><br><b>IMPORTANT! PLEASE READ CAREFULLY BEFORE USING. YOUR USE OF THE SERVICES IS YOUR ACKNOWLEDGMENT AND AGREEMENT THAT YOU AGREE WITH THE TERMS SET FORTH BELOW.</b></center><br><br><b>ACCEPTANCE OF TERMS THROUGH USE</b><br>By using these services (the "Services"), you agree to all terms, conditions, and notices contained herein. The Hotel reserves the right, in its sole discretion, to terminate your access to all or part of the Services, with or without notice.<br><br><b>DISCLAIMER OF WARRANTIES</b><br>ALL MATERIALS, INFORMATION, SOFTWARE, PRODUCTS, AND SERVICES INCLUDED IN OR AVAILABLE BY THE HOTEL ARE PROVIDED "AS IS". THE HOTEL, ITS SUBSIDIARIES, AFFILIATES, OWNER, AND ITS REPRESENTATIVES ACCEPT NO LIABILITY FOR ANY PROBLEMS ASSOCIATED WITH YOUR USE OF THE SERVICES, INCLUDING, BUT NOT LIMITED TO, DAMAGE TO YOUR SOFTWARE, HARDWARE, OR OTHER EQUIPMENT; ANY DELAY IN OPERATION OR TRANSMISSION OF THE SERVICES; ANY COMMUNICATIONS LINE FAILURE, THEFT OR DESTRUCTION; ANY PROBLEMS OR TECHNICAL MALFUNCTION OF ANY TELEPHONE NETWORK OR LINES, COMPUTER ON-LINE SYSTEMS, SERVERS, PROVIDERS, OR COMPUTER EQUIPMENT; OR ANY TRAFFIC CONGESTION OF FAILURE OF THE INTERNET OR ANY WEB SITE. THE SERVICES ARE PROVIDED WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, OR NONINFRINGEMENT. THE HOTEL, ITS SUBSIDIARIES, AFFILIATES, OWNER, AND ITS REPRESENTATIVES DO NOT WARRANT THAT THE SERVICES ARE ACCURATE, RELIABLE OR CORRECT; THAT THE SERVICES WILL BE UNINTERRUPTED OR AVAILABLE AT ANY PARTICULAR TIME OR LOCATION; THAT THE SERVICES ARE SECURE OR THAT ANY WIRELESS OR WIRED CONNECTION WILL NOT BE ACCESSED, INTERCEPTED, ALTERED OR DESTROYED IN WHOLE OR IN PART BY AN UNAUTHORIZED THIRD PARTY; THAT ANY DATA FILES, PROGRAMS, PROCEDURES OR INFORMATION (INCLUDING YOUR PERSONALLY IDENTIFIABLE INFORMATION) DOWNLOADED, RECORDED, TRANSMITTED OR INPUT THROUGH THE SERVICES WILL BE SECURE OR PROTECTED FROM UNAUTHORIZED ACCESS TO, ALTERATION, DELETION, DEFECT OR DESTRUCTION; THAT ANY DEFECTS OR ERRORS WILL BE CORRECTED; OR THAT THE CONTENT OR SERVICES ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS. SOME JURISDICTIONS DO NOT PERMIT THE EXCLUSION OF CERTAIN WARRANTIES, SO THESE EXCLUSIONS MAY NOT APPLY TO YOU.<br><br><b>LIMITATION OF LIABILITY</b><br>UNDER NO CIRCUMSTANCES SHALL THE HOTEL, ITS SUBSIDIARIES, AFFILIATES, OWNER OR ITS REPRESENTATIVES BE LIABLE FOR ANY DIRECT, INDIRECT, PUNITIVE, INCIDENTAL, SPECIAL, OR CONSEQUENTIAL DAMAGES THAT RESULT FROM THE USE OF OR INABILITY TO USE, THE SERVICES. THIS LIMITATION APPLIES EVEN IF THE HOTEL HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE. SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF INCIDENTAL OR CONSEQUENTIAL DAMAGES, SO THE HOTEL'S LIABILITY IN SUCH JURISDICTIONS SHALL BE LIMITED TO THE MAXIMUM EXTENT PERMITTED BY LAW.<br><br><b>INDEMNIFICATION</b><br>You shall defend, indemnify and hold the Hotel and its owners, subsidiaries and other affiliated companies, and their employees, contractors, officers, and directors harmless from all liabilities, claims, and expenses, including attorney's fees resulting from your use or misuse of the Services.<br><br><b>THIRD PARTY SITES</b><br>Your use of the Services may business center you to other sites on the Internet. These sites may contain information or material that some people may find inappropriate or offensive. These other sites are not under the control of the Hotel, and you acknowledge that the Hotel is not responsible for the accuracy, legality, decency, or any other aspect of the content of such sites. The inclusion of such a business center does not imply endorsement of the site by the Hotel.<br><br><b>RULES OF CONDUCT</b><br>You agree not to use these Services for unlawful purposes or in an offensive manner, including, without limitation, usage that (i) is threatening, abusive, harassing, defamatory, libelous, deceptive, fraudulent, invasive of another's privacy, tortious, or (ii) contains language (sexual or otherwise) of a violent or threatening nature directed at another individual or group of individuals, or victimizes, harasses, degrades, or intimidates an individual or group of individuals on the basis of religion, gender, sexual orientation, race, ethnicity, age, or disability. You shall also be prohibited from usage that infringes any patent, trademark, trade secret, copyright, right of publicity, or other proprietary right of any party (collectively, "Intellectual Property"). You shall not introduce any software viruses or any other computer code, files, or programs that are designed or intended to disrupt, damage, or limit the functioning of any software, hardware, or telecommunications equipment or to damage or obtain unauthorized access to any data or other information of any third party. You further agree that you will not knowingly solicit or collect personal information from a minor (anyone under 18 yrs old) without appropriate prior verifiable parental consent. The Hotel makes no representation that materials accessed through the Service are appropriate or available for use in locations outside the United States, and accessing them from territories where their contents are illegal is prohibited.<br><br><b>MONITORING</b><br>The Hotel, its subsidiaries, affiliates, owner or its representatives have no obligation to monitor, track, record, store or disclose your use of the Services, including, without limitation, the URLs of the websites you visit and the data you enter, transmit, or receive, but may do so (i) to comply with legal or regulatory requirements or to assist in law enforcement investigations and procedures; (ii) to operate the Services properly; (iii) to ensure compliance with the terms and conditions herein; or (iv) based on a good faith belief that such monitoring, tracking, recording, storing, or disclosure is otherwise necessary or advisable including, without limitation, if there is reason to believe that such information is necessary to identify, contact or bring legal action against someone who may be causing interference with our rights or properties, whether intentionally or otherwise, or when anyone else could be harmed by such activities.<br><br><b>PROPRIETARY RIGHTS</b><br>You acknowledge and agree that all content and materials available to you through these Services are protected by Intellectual Property rights and laws. Reproduction, copying, or redistribution for commercial purposes of any materials or design elements obtained through these Services is strictly prohibited without the express written permission of Intellectual Property owner.<br><br><b>REVISIONS</b><br>The Hotel reserves the right, in it sole discretion, to update or revise these terms from time to time.`,
    };
  },
  filters: {
    phone: function (value) {
      if (!value) return "";
      value = value.toString();
      return (
        "(" +
        value.substr(0, 3) +
        ") " +
        value.substr(3, 3) +
        "-" +
        value.substr(6, 4)
      );
    },
  },
  mounted() {
    if (this.portal.template.support_phone) {
      this.doc.support_phone = this.portal.template.support_phone;
    }

    this.generateRegistrationMethods();
  },
  methods: {
    generateRegistrationMethods: function () {
      for (let i in this.portal.registration_methods) {
        let rm = this.portal.registration_methods[i];
        for (let c in rm.rate_plans) {
          let rateplan = rm.rate_plans[c];
          let plan = {
            name:
              rm.free === 0 ? rateplan.rate_plan_name : rm.registration_method,
            type: "rateplan",
            registration_method_id: rm.registration_method_id,
            id: rateplan.rateplan_id,
            price: rateplan.price,
            duration: rateplan.duration,
            speed_upload: rateplan.speed_upload,
            speed_download: rateplan.speed_download,
            additional_devices: rateplan.additional_devices,
            terms_of_service: this.terms_of_service,
          };
          this.registration_methods.push(plan);
        }
      }
      if (this.portal.access_codes.length > 0) {
        let plan = {
          name: "Access Code",
          type: "accesscode",
          registration_method_id: 4,
          terms_of_service: this.terms_of_service,
        };
        this.registration_methods.push(plan);
      }
      if (this.registration_methods.length === 1) {
        this.doc.selected_rm = 0;
      }
    },
    // Change selected registration method from emitted data
    changeSelected: function (index) {
      this.doc.selected_rm = index;
    },
    // Change selected terms of service from emitted data
    changeSelectedTOS: function (index) {
      this.doc.selected_tos = index;
    },

    emitCustomError: function (error) {
      this.error.status = "Error";
      this.error.message = error;
      this.changeLoadState("error");
    },
    // Send registration method details back to parent
    emitRegistrationMethodData: function (emitted) {
      this.emitted = emitted;
      this.$emit("emitRegistrationMethodData", this.emitted);
    },
  },
};
</script>

<style>
* {
  border-color: unset;
}

html {
  background:linear-gradient( rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5) ), url('./assets/bg.jpeg') no-repeat center center fixed; 
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

.row {
  color: white;
  width: 100%;
}

#rms {
  width: 50%;
  margin: 0 auto;
}

@media screen and (max-device-width: 480px) {
  #rms {
    width: 100%;
  }
}

#logo {
  padding: 4%;
}
</style>
